<template>
  <button @click="toOpen">
    <SearchIcon :style="{ width: '15px', height: '15px' }"/>
  </button>
</template>

<script setup>
  import { onMounted, computed } from 'vue';
  import { useStore } from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //-------------------------------------
  import SearchIcon from '@shared/UI/SVG/navigation/SearchIcon.vue';
  //-------------------------------------
  const store = useStore();
  //-------------------------------------
  onMounted(() => {
    initEventListener();
  })
  //-------------------------------------
  //Запустить прослушивания события на нажатие кнопки '/'
  const initEventListener = () => {
    window.addEventListener('keydown', (e) => {
      toUseSlashForOpenWidget(e);
    });
  }
  //Открыть виджет через '/' 
  const toUseSlashForOpenWidget = (e) => {
    const isSlashKey = (e.key === '/');
    if(!isSlashKey || !checkIsAllowedUseSlash.value) return;
    e.preventDefault(); 
    store.commit('SearchSystem/toChangeFocusOnOpenStatus', true);
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.search);
  }
  //Разрешен ли вызов окна поиска через нажатие на клавишу '/'
  const checkIsAllowedUseSlash = computed(() => { 
    const noOpenPopus = store.state.Dropdowns.list.length <= 0;
    const noFocusFields = !store.state.FormsInterfaceSystem.isFocusFormTextElement;
    return noOpenPopus && noFocusFields;
  });
  //Открыть виджет
  const toOpen = () => {
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.search);
  }
</script>

<style lang="scss" scoped>
  @import './styles';
</style>